import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.25 22.5v1.25-17.5zm.385 3.125q-.935 0-1.598-.662a2.18 2.18 0 0 1-.662-1.598V6.635q0-.936.662-1.598a2.18 2.18 0 0 1 1.598-.662h16.73q.936 0 1.598.662.662.663.662 1.598v3.401H23.75V6.635a.37.37 0 0 0-.108-.277.37.37 0 0 0-.277-.108H6.635a.37.37 0 0 0-.277.108.37.37 0 0 0-.108.277v16.73q0 .17.108.277a.37.37 0 0 0 .277.108h16.73a.38.38 0 0 0 .277-.108.38.38 0 0 0 .108-.277v-3.401h1.875v3.401q0 .935-.662 1.598a2.18 2.18 0 0 1-1.598.662zm10-5q-.935 0-1.598-.662a2.18 2.18 0 0 1-.662-1.598v-6.73q0-.935.662-1.598a2.18 2.18 0 0 1 1.598-.662h7.98q.935 0 1.598.662.662.662.662 1.598v6.73q0 .935-.662 1.598a2.18 2.18 0 0 1-1.598.662zm7.98-1.875a.38.38 0 0 0 .277-.108.38.38 0 0 0 .108-.277v-6.73a.37.37 0 0 0-.108-.277.37.37 0 0 0-.277-.108h-7.98a.37.37 0 0 0-.277.108.37.37 0 0 0-.108.277v6.73q0 .17.108.277a.37.37 0 0 0 .277.108zM20 16.875q.78 0 1.328-.547.547-.546.547-1.328 0-.781-.547-1.328A1.8 1.8 0 0 0 20 13.125q-.781 0-1.328.547A1.8 1.8 0 0 0 18.125 15q0 .78.547 1.328.546.547 1.328.547"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
